export const LOADER_STATE_MISSING_INFO = 'missing_info'
export const LOADER_STATE_MISSING = 'missing'
export const LOADER_STATE_IGNORE = 'ignore'
export const LOADER_STATE_OK = 'ok'
export const LOADER_STATE_DATE_INCONSISTENCY = 'date_inconsistency'
export const LOADER_STATE_STORAGE_PLACE_INCONSISTENCY =
  'storage_place_inconsistency'
export const LOADER_STATE_STORAGE_PLACE_MAXED = 'storage_place_maxed'

export const LOADER_CORRECT_STATES = [
  LOADER_STATE_MISSING,
  LOADER_STATE_IGNORE,
  LOADER_STATE_OK,
]
export const LOADER_WARNING_STATES = [
  LOADER_STATE_DATE_INCONSISTENCY,
  LOADER_STATE_STORAGE_PLACE_INCONSISTENCY,
  LOADER_STATE_STORAGE_PLACE_MAXED,
]
export const LOADER_ERROR_STATES = [LOADER_STATE_MISSING_INFO]

export const LOADER_ALL_STATES = [
  ...LOADER_CORRECT_STATES,
  ...LOADER_WARNING_STATES,
  ...LOADER_ERROR_STATES,
]
